import React from 'react';

import { dataPieChar, subDataPie } from '../types/pieChart.types';
import { meses } from '../consts/meses';
import { EstadoLlaveAnual } from '../../bussines/entities/EstadisticasLlave.entity';

type fnMapperEstadoLlavesToDataPieChar = (params: { data: EstadoLlaveAnual[] }) => dataPieChar[];

export const mapperEstadoLlavesToDataPieChar: fnMapperEstadoLlavesToDataPieChar = ({ data }) => {
   // Objeto de agrupación
   const mesesAgrupados = data.reduce((acc, { estado, mes, producto, value }) => {
      if (mes !== 0) {
         acc[mes] = acc[mes] || {};
         acc[mes][estado] = acc[mes][estado] || {};
         acc[mes][estado][producto] = acc[mes][estado][producto] || [];

         acc[mes][estado][producto].push({
            etiqueta: producto,
            value
         })
      }
      return acc;
   }, {} as Record<number, Record<string, Record<string, subDataPie[]>>>);

   // Función para sumar el total de los valores de un conjunto de datos
   const sumValues = (data: subDataPie[]) => data.reduce((acc, curr) => acc + curr.value, 0);

   // Creamos el objeto final con la suma de valores por mes, producto, usuario y cliente
   const dataPorMeses: dataPieChar[] = Object.entries(mesesAgrupados).map(([mes, estados]) => {
      const estadosList = Object.entries(estados).map(([estado, productos]) => {
         const productosList = Object.entries(productos).map(([producto, valores]) => ({
            etiqueta: producto,
            value: sumValues(valores)
         }));
         return {
            etiqueta: estado,
            value: sumValues(productosList),
            subData: productosList
         };
      });
      return {
         mes: Number(mes),
         denominacion: meses[Number(mes) - 1].labelLong, // Nombre completo del mes
         mark: meses[Number(mes) - 1].label, // Abreviatura del mes
         subData: estadosList
      };
   });

   return dataPorMeses;
};
